import { CalendarDay } from '../../../utils';
import withPaginationParams from '../../helpers/with-pagination-params';
import { z } from 'zod';

const listBaseSchema = z.object({
  uploadStartDate: z.instanceof(CalendarDay).optional(),
  uploadEndDate: z.instanceof(CalendarDay).optional(),
  paymentStartDate: z.instanceof(CalendarDay).optional(),
  paymentEndDate: z.instanceof(CalendarDay).optional(),
});

export const ListInterestPaymentsInput = withPaginationParams(listBaseSchema, [
  'dates',
  'createdAt',
  'totalInterest',
]).refine(
  (data) => {
    const hasUploadStart = !!data.uploadStartDate;
    const hasUploadEnd = !!data.uploadEndDate;

    const hasPaymentStart = !!data.paymentStartDate;
    const hasPaymentEnd = !!data.paymentEndDate;

    const uploadValid =
      (hasUploadStart && hasUploadEnd) || (!hasUploadStart && !hasUploadEnd);
    const paymentValid =
      (hasPaymentStart && hasPaymentEnd) ||
      (!hasPaymentStart && !hasPaymentEnd);

    return uploadValid && paymentValid;
  },
  {
    message:
      'If a start date is present, the corresponding end date must also be present.',
  },
);

export const DownloadInterestPaymentInput = z.object({
  uploadId: z.string(),
});

export const DeleteInterestPaymentInput = z.object({
  uploadId: z.string(),
});

export const CreateUploadDocumentInput = z.object({
  selectedTrancheIds: z.array(z.string()),
  interestPaymentsDate: z.instanceof(CalendarDay),
});

export const ProcessUploadInput = z.object({
  filePath: z.string(),
  ignoreWarnings: z.boolean(),
});
